import { useNavigate } from "react-router-dom";

export const IntroOfferBanner = ({ testPrefix = "" }) => {
  const navigate = useNavigate();
  const tid = (id) => (testPrefix ? `${testPrefix}-${id}` : id);
  return (
    <div data-testid={tid("intro-offer-banner")}
      className="max-w-5xl mx-auto bg-[#0B0F0D] border-2 border-[#D4AF37] rounded-2xl px-6 py-7 sm:px-10 flex flex-col md:flex-row items-center gap-6 md:gap-8 shadow-xl shadow-amber-900/10">
      <div className="flex-1 text-center md:text-left">
        <span className="inline-block bg-gradient-to-r from-amber-500 to-yellow-500 text-slate-950 text-xs font-extrabold tracking-wider px-3.5 py-1.5 rounded-full uppercase">Headline Offer</span>
        <h2 className="font-display text-white font-extrabold text-2xl sm:text-3xl mt-3 leading-tight">
          Join for 1 month for just <span className="text-[#D4AF37]">£4.99</span> — full access
        </h2>
        <p className="text-gray-400 text-sm mt-2 max-w-xl">
          Instant full Pro access to the entire searchable command dictionary for a whole month.
          Then just £47/year — cancel any time before your month ends and pay nothing more.
        </p>
      </div>
      <button data-testid={tid("intro-offer-join-btn")} onClick={() => navigate("/checkout/pro_intro")}
        className="shrink-0 bg-gradient-to-r from-amber-500 to-yellow-500 text-slate-950 font-extrabold text-base px-8 py-4 rounded-xl hover:brightness-105 active:scale-[0.98] transition-all shadow-lg shadow-amber-500/20">
        JOIN NOW — £4.99
      </button>
    </div>
  );
};
